/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_HintInputs */

const cs_auth_totp_hint = /** @type {(inputs: Auth_Totp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte 6místný kód z autentikační aplikace.`)
};

const en_auth_totp_hint = /** @type {(inputs: Auth_Totp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the 6-digit code from your authenticator app.`)
};

/**
* | output |
* | --- |
* | "Enter the 6-digit code from your authenticator app." |
*
* @param {Auth_Totp_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_totp_hint = /** @type {((inputs?: Auth_Totp_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_totp_hint(inputs)
	return cs_auth_totp_hint(inputs)
});